export default "__VITE_ASSET__j7Ty4pY9__"